module.exports = __webpack_public_path__ + "img/med0004.ba055a1e.png";